import { Component, Input } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-company-delete-confirm-modal',
  templateUrl: './company-delete-confirm-modal.component.html',
  styleUrls: ['./company-delete-confirm-modal.component.scss']
})
export class CompanyDeleteConfirmModalComponent extends DialogContentBase {
  @Input() bodyMessage: string = '';
  @Input() data: any = '';
  @Input() company: any;
  constructor(
    public dialog: DialogRef
  ) {
    super(dialog);
  }

  public close(result = false) {
    this.dialog.close(result);
  }
}
